
class EventElement {
  
  constructor(element) {
    this.element = element;
    this.events = {};
  }

  bind(eventName, handler, options=false) {
    if (typeof this.events[eventName] === 'undefined') {
      this.events[eventName] = [];
    }
    this.events[eventName].push(handler);
    this.element.addEventListener(eventName, handler, options);
  }

  unbind(eventName, handler=false) {
    var isHandlerProvided = (handler !== false);
    this.events[eventName] = this.events[eventName].filter(function (hdlr) {
      if (isHandlerProvided && hdlr !== handler) {
        return true;
      }
      this.element.removeEventListener(eventName, hdlr, false);
      return false;
    }, this);
  }

  unbindAll() {
    for (var name in this.events) {
      this.unbind(name);
    }
  }

}

class EventManager{
  
  constructor () {
    this.eventElements = [];
  }

  eventElement(element) {
    var ee = this.eventElements.filter(function (eventElement) {
      return eventElement.element === element;
    })[0];
    if (typeof ee === 'undefined') {
      ee = new EventElement(element);
      this.eventElements.push(ee);
    }
    return ee;
  }

  bind(element, eventName, handler, options=false) {
    this.eventElement(element).bind(eventName, handler, options);
  }

  unbind(element, eventName, handler) {
    this.eventElement(element).unbind(eventName, handler);
  }

  unbindAll() {
    for (var i = 0; i < this.eventElements.length; i++) {
      this.eventElements[i].unbindAll();
    }
  }

  once(element, eventName, handler) {
    var ee = this.eventElement(element);
    var onceHandler = function (e) {
      ee.unbind(eventName, onceHandler);
      handler(e);
    };
    ee.bind(eventName, onceHandler);
  }

}

export default EventManager;
